import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import FJTextToImageStylesContainer from '../container/FJTextToImageStylesContainer';
import FJTextToImagePromptContainer from '../container/FJTextToImagePromptContainer';
import FJTextToImageModelSelectorContainer from '../container/FJTextToImageModelSelectorContainer';
import FJTextToImageImageUploaderContainer from '../container/FJTextToImageImageUploaderContainer';
import FJTextToImageRatioContainer from '../container/FJTextToImageRatioContainer';
import FJTextToImageGenerateNumberContainer from '../container/FJTextToImageGenerateNumberContainer';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import useDefaultFreeLimit from '../../../../hooks/useDefaultFreeLimit.jsx';
import { MODELS_VALUE } from '../../../../config/dataConfig/FJTextToImageDataConfig';
import FJTextToImageResolutionContainer from '../container/FJTextToImageResolutionContainer';

import styles from './FJTextToImageLeft.module.less';
import FJGeneratePrivacySettingsContainer from '../container/FJGeneratePrivacySettingsContainer.jsx';

const FJTextToImageLeft = ({
    generate,
    taskStatus,
    freeNumCreation,
    isProjectLoading,
    useCredit,
    creditNumber,
    isShowStylePrompt,
    isShowImageUploader,
    curModel,
}) => {
    const defaultFreeNumCreation = useDefaultFreeLimit();

    const isFree = useMemo(() => {
        return freeNumCreation > 0 && useCredit > creditNumber && curModel === MODELS_VALUE.FLUX_SCHNELL;
    }, [freeNumCreation, useCredit, creditNumber, curModel]);

    return (
        <FJAppLeft className={styles.text_to_image_left}>
            <FJVerticalScroller className={styles.text_to_image_left_scroller}>
                <FJTextToImageModelSelectorContainer />
                <FJTextToImagePromptContainer id='textToImagePrompt' />
                <div style={{ padding: '20px 0' }}>
                    {isShowStylePrompt && <FJTextToImageStylesContainer id='textToImageStyle' />}

                    {isShowImageUploader && <FJTextToImageImageUploaderContainer />}

                    <FJTextToImageResolutionContainer />

                    <FJTextToImageRatioContainer />

                    <FJTextToImageGenerateNumberContainer />

                    <FJGeneratePrivacySettingsContainer />
                </div>
            </FJVerticalScroller>

            <div className={styles.generate_btn_box}>
                <FJGenerateButton
                    className={styles.generate_btn}
                    onClick={generate}
                    taskStatus={taskStatus}
                    isFree={isFree}
                    freeNumCreation={freeNumCreation}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                    isShowUsageDetail={true}
                    id='textToImageBtn'
                    defaultFreeNumCreation={curModel === MODELS_VALUE.FLUX_SCHNELL ? defaultFreeNumCreation : 0}
                />
            </div>
        </FJAppLeft>
    );
};

FJTextToImageLeft.propTypes = {
    generate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    useCredit: PropTypes.number,
    creditNumber: PropTypes.number,
    isShowStylePrompt: PropTypes.bool,
    isShowImageUploader: PropTypes.bool,
    curModel: PropTypes.string,
};

export default FJTextToImageLeft;
